 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import E9781534440180XHTMLCOVER from '@/components/e9781534440180/xhtml/cover'
 import E9781534440180XHTMLTITLE from '@/components/e9781534440180/xhtml/title'
 import E9781534440180XHTMLDEDICATION from '@/components/e9781534440180/xhtml/dedication'
 import E9781534440180XHTMLCH01 from '@/components/e9781534440180/xhtml/ch01'
 import E9781534440180XHTMLCH01A from '@/components/e9781534440180/xhtml/ch01a'
 import E9781534440180XHTMLCH01B from '@/components/e9781534440180/xhtml/ch01b'
 import E9781534440180XHTMLCH02 from '@/components/e9781534440180/xhtml/ch02'
 import E9781534440180XHTMLCH02A from '@/components/e9781534440180/xhtml/ch02a'
 import E9781534440180XHTMLCH02B from '@/components/e9781534440180/xhtml/ch02b'
 import E9781534440180XHTMLCH03 from '@/components/e9781534440180/xhtml/ch03'
 import E9781534440180XHTMLCH03A from '@/components/e9781534440180/xhtml/ch03a'
 import E9781534440180XHTMLCH03B from '@/components/e9781534440180/xhtml/ch03b'
 import E9781534440180XHTMLCH04 from '@/components/e9781534440180/xhtml/ch04'
 import E9781534440180XHTMLCH04A from '@/components/e9781534440180/xhtml/ch04a'
 import E9781534440180XHTMLCH04B from '@/components/e9781534440180/xhtml/ch04b'
 import E9781534440180XHTMLCH05 from '@/components/e9781534440180/xhtml/ch05'
 import E9781534440180XHTMLCH05A from '@/components/e9781534440180/xhtml/ch05a'
 import E9781534440180XHTMLCH05B from '@/components/e9781534440180/xhtml/ch05b'
 import E9781534440180XHTMLCH06 from '@/components/e9781534440180/xhtml/ch06'
 import E9781534440180XHTMLCH06A from '@/components/e9781534440180/xhtml/ch06a'
 import E9781534440180XHTMLCH06B from '@/components/e9781534440180/xhtml/ch06b'
 import E9781534440180XHTMLCH07 from '@/components/e9781534440180/xhtml/ch07'
 import E9781534440180XHTMLCH07A from '@/components/e9781534440180/xhtml/ch07a'
 import E9781534440180XHTMLCH07B from '@/components/e9781534440180/xhtml/ch07b'
 import E9781534440180XHTMLCH08 from '@/components/e9781534440180/xhtml/ch08'
 import E9781534440180XHTMLCH08A from '@/components/e9781534440180/xhtml/ch08a'
 import E9781534440180XHTMLCH08B from '@/components/e9781534440180/xhtml/ch08b'
 import E9781534440180XHTMLCH09 from '@/components/e9781534440180/xhtml/ch09'
 import E9781534440180XHTMLCH09A from '@/components/e9781534440180/xhtml/ch09a'
 import E9781534440180XHTMLCH09B from '@/components/e9781534440180/xhtml/ch09b'
 import E9781534440180XHTMLCH10 from '@/components/e9781534440180/xhtml/ch10'
 import E9781534440180XHTMLCH10A from '@/components/e9781534440180/xhtml/ch10a'
 import E9781534440180XHTMLCH10B from '@/components/e9781534440180/xhtml/ch10b'
 import E9781534440180XHTMLCH11 from '@/components/e9781534440180/xhtml/ch11'
 import E9781534440180XHTMLCH11A from '@/components/e9781534440180/xhtml/ch11a'
 import E9781534440180XHTMLCH11B from '@/components/e9781534440180/xhtml/ch11b'
 import E9781534440180XHTMLCH12 from '@/components/e9781534440180/xhtml/ch12'
 import E9781534440180XHTMLCH12A from '@/components/e9781534440180/xhtml/ch12a'
 import E9781534440180XHTMLCH12B from '@/components/e9781534440180/xhtml/ch12b'
 import E9781534440180XHTMLCH13 from '@/components/e9781534440180/xhtml/ch13'
 import E9781534440180XHTMLCH13A from '@/components/e9781534440180/xhtml/ch13a'
 import E9781534440180XHTMLCH13B from '@/components/e9781534440180/xhtml/ch13b'
 import E9781534440180XHTMLCH14 from '@/components/e9781534440180/xhtml/ch14'
 import E9781534440180XHTMLCH14A from '@/components/e9781534440180/xhtml/ch14a'
 import E9781534440180XHTMLCH14B from '@/components/e9781534440180/xhtml/ch14b'
 import E9781534440180XHTMLACK from '@/components/e9781534440180/xhtml/ack'
 import E9781534440180XHTMLSS_RECOMMENDPAGE from '@/components/e9781534440180/xhtml/SS_recommendpage'
 import E9781534440180XHTMLAUTHORBIO from '@/components/e9781534440180/xhtml/authorbio'
 import E9781534440180XHTMLADCARD from '@/components/e9781534440180/xhtml/adcard'
 import E9781534440180XHTMLBACKAD from '@/components/e9781534440180/xhtml/backad'
 import E9781534440180XHTMLCOPYRIGHT from '@/components/e9781534440180/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/e9781534440180/xhtml/cover",
 			"name" : "e9781534440180/xhtml/cover",
 			"component" : E9781534440180XHTMLCOVER
 		},
 		{
 			"path" : "/e9781534440180/xhtml/title",
 			"name" : "e9781534440180/xhtml/title",
 			"component" : E9781534440180XHTMLTITLE
 		},
 		{
 			"path" : "/e9781534440180/xhtml/dedication",
 			"name" : "e9781534440180/xhtml/dedication",
 			"component" : E9781534440180XHTMLDEDICATION
 		},
 		{
 			"path" : "/e9781534440180/xhtml/ch01",
 			"name" : "e9781534440180/xhtml/ch01",
 			"component" : E9781534440180XHTMLCH01
 		},
 		{
 			"path" : "/e9781534440180/xhtml/ch01a",
 			"name" : "e9781534440180/xhtml/ch01a",
 			"component" : E9781534440180XHTMLCH01A
 		},
 		{
 			"path" : "/e9781534440180/xhtml/ch01b",
 			"name" : "e9781534440180/xhtml/ch01b",
 			"component" : E9781534440180XHTMLCH01B
 		},
 		{
 			"path" : "/e9781534440180/xhtml/ch02",
 			"name" : "e9781534440180/xhtml/ch02",
 			"component" : E9781534440180XHTMLCH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js